import type { PromptDetail, Thread } from "@/lib/prompt-audit-api"

function quoteLines(text: string): string {
  return text.split("\n").map((line) => `> ${line}`).join("\n")
}

export function exportMarkdown(detail: PromptDetail, threads: Thread[]): string {
  const header = [
    `# ${detail.title}`,
    "",
    `- Group: ${detail.group}`,
    `- Source: ${detail.source}`,
    `- sha256: ${detail.sha256}`,
    `- Characters: ${detail.chars}`,
    `- Exported: ${new Date().toISOString()}`,
  ]
  const comments = threads.map((thread, index) => {
    const lines = [
      `### Comment ${index + 1} (${thread.anchor.status}${thread.resolved_at ? ", resolved" : ""})`,
      "",
      quoteLines(thread.quote),
      "",
      `**${thread.author_email}** (${thread.created_at}): ${thread.body}`,
      ...thread.replies.map((reply) => `\n**${reply.author_email}** (${reply.created_at}): ${reply.body}`),
    ]
    return lines.join("\n")
  })
  return [
    ...header,
    "",
    "## Comments",
    "",
    comments.length ? comments.join("\n\n") : "No comments.",
    "",
    "## Prompt text",
    "",
    "````text",
    detail.text,
    "````",
    "",
  ].join("\n")
}

export function downloadText(filename: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: "text/markdown;charset=utf-8" }))
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
